<div class="tab-container">
  <ul class="tab">
    <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [className]='tab.active ? "tab-active":"tab-non-active"'>
      {{tab.title}}</li>
  </ul>
  <ng-content></ng-content>
</div>